module.exports = __webpack_public_path__ + "static/media/pla_gas_cyl_bio.9fd69286.png";